import React, { useMemo, useState, createContext } from 'react';
import { parseLog } from '../utils/common';
export var LoggerContext = createContext({
    logText: '',
    updateGlobalLog: function () { return ''; },
});
export function LoggerProvider(_a) {
    var children = _a.children, logKey = _a.logKey, _b = _a.defaultData, defaultData = _b === void 0 ? '' : _b;
    var _c = useState(defaultData), logText = _c[0], updateGlobalLog = _c[1];
    var context = useMemo(function () { return ({
        logText: logText,
        updateGlobalLog: function (args) {
            var data = parseLog(args, logKey, true);
            return updateGlobalLog(data);
        },
    }); }, [logText]);
    return (React.createElement(LoggerContext.Provider, { value: context }, children));
}
